import { FONTS } from "../constants";
import { stateType } from "../state";
import LogoName, { LogoName2 } from "./Common/LogoName2";

export function LoadingDashboard({ state }: stateType) {
  return (
    <div
      style={{
        width: "900px",
        height: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          paddingTop: "10px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <LogoName></LogoName>
          <div
            style={{
              color: "rgba(0,0,0,0.7)",
              fontFamily: FONTS,
              width: "100%",
              textAlign: "center",
              paddingTop: "30px",
              fontSize: "40px",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export function SavingDashboard({ state }: stateType) {
  return (
    <div
      style={{
        width: "900px",
        height: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          paddingTop: "10px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <LogoName2></LogoName2>
          <div
            style={{
              color: "rgba(0,0,0,0.7)",
              fontFamily: FONTS,
              width: "100%",
              textAlign: "center",
              paddingTop: "30px",
              fontSize: "40px",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
